<p-panel header="{{ 'PRODUCTOACTIVIDAD.LBL_ACTIVIDADES' | translate}}">
  <div *ngIf="seccion === 'LISTADO'">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <button type="button" pButton icon="fa fa-plus" (click)="crear()"
                label="{{ 'BTN_AGREGAR' | translate}}"></button>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dtproductoactividad.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="carTabla" #dtproductoactividad
                 [value]="lisProductoActividad" selectionMode="single" dataKey="idProductoActividad"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreSegmento}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" (onChange)="cambiarHabilitado(row)"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                          title="{{'BTN_VISUALIZAR' | translate}}"
                          pButton (click)="ver(row)"></button>
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                          title="{{'BTN_EDITAR' | translate}}" pButton
                          (click)="editar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <app-producto-actividad-aliado-detalle (dismiss)="cambioSeccion($event)" *ngIf="seccion === 'DETALLE'"
                                         [proActividad]="proActividadSeleccionado"></app-producto-actividad-aliado-detalle>

  <app-producto-actividad-aliado-editar (dismiss)="cambioSeccion($event)" [producto]="producto" [proActividad]="proActividadSeleccionado"
                                        (listado)="actualizarListado($event)"
                                        [lisProductoActividad]="lisProductoActividad"
                                        *ngIf="seccion === 'EDITAR'"></app-producto-actividad-aliado-editar>
</p-panel>


<p-confirmDialog #cd key="actividades">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
